<template src="./DashboardComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";

export default {
  name: 'DashboardComponent',
  components: {BreadcrumbComponent, IconHome},
  setup() {
    // function getList
  }
}
</script>
<style lang="scss">
  .dashboard-page {
    margin-top: 80px;
    margin-left: 265px;
    height: 100%;
    .title-page {
      padding: 15px 30px;
      background-color: #fff;
    }
  }
</style>
